// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveHomeownerUndecidedSelectionMutationVariables = Types.Exact<{
  input: Types.HomeownerSelectionInput;
}>;


export type SaveHomeownerUndecidedSelectionMutation = { __typename?: 'Mutation', saveHomeownerSelection: { __typename?: 'SaveHomeownerSelectionResult', homeownerSelection: { __typename?: 'HomeownerSelection', id: string, undecidedUnitCostInCents?: number | null | undefined, undecidedUnitPriceInCents?: number | null | undefined, projectItem: { __typename?: 'ProjectItem', id: string, totalCostInCents: number, totalPriceInCents: number }, changeEventLineItem?: { __typename?: 'ChangeEventLineItem', id: string, proposedBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string } | null | undefined } | null | undefined, selectedOption?: { __typename?: 'HomeownerSelectionOption', id: string } | null | undefined, status: { __typename?: 'HomeownerSelectionStatusDetail', code: Types.HomeownerSelectionStatus, name: string }, options: Array<{ __typename?: 'HomeownerSelectionOption', id: string, isSelectedOption: boolean, product: { __typename?: 'Product', id: string, bidItems: Array<{ __typename?: 'BidItem', id: string }> } }> } } };

export type SelectionOptions_HomeownerSelectionFragment = { __typename?: 'HomeownerSelection', id: string, undecidedUnitCostInCents?: number | null | undefined, undecidedUnitPriceInCents?: number | null | undefined, selectedOption?: { __typename?: 'HomeownerSelectionOption', id: string } | null | undefined, status: { __typename?: 'HomeownerSelectionStatusDetail', code: Types.HomeownerSelectionStatus, name: string }, options: Array<{ __typename?: 'HomeownerSelectionOption', id: string, isSelectedOption: boolean, product: { __typename?: 'Product', id: string, bidItems: Array<{ __typename?: 'BidItem', id: string }> } }> };

export const SelectionOptions_HomeownerSelectionFragmentDoc = gql`
    fragment SelectionOptions_HomeownerSelection on HomeownerSelection {
  id
  undecidedUnitCostInCents
  undecidedUnitPriceInCents
  selectedOption {
    id
  }
  status {
    code
    name
  }
  options {
    id
    isSelectedOption
    product {
      id
      bidItems {
        id
      }
    }
  }
}
    `;
export const SaveHomeownerUndecidedSelectionDocument = gql`
    mutation SaveHomeownerUndecidedSelection($input: HomeownerSelectionInput!) {
  saveHomeownerSelection(input: $input) {
    homeownerSelection {
      ...SelectionOptions_HomeownerSelection
      projectItem {
        id
        totalCostInCents
        totalPriceInCents
      }
      changeEventLineItem {
        id
        proposedBidContractLineItem {
          id
        }
      }
    }
  }
}
    ${SelectionOptions_HomeownerSelectionFragmentDoc}`;
export type SaveHomeownerUndecidedSelectionMutationFn = Apollo.MutationFunction<SaveHomeownerUndecidedSelectionMutation, SaveHomeownerUndecidedSelectionMutationVariables>;

/**
 * __useSaveHomeownerUndecidedSelectionMutation__
 *
 * To run a mutation, you first call `useSaveHomeownerUndecidedSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHomeownerUndecidedSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHomeownerUndecidedSelectionMutation, { data, loading, error }] = useSaveHomeownerUndecidedSelectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveHomeownerUndecidedSelectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveHomeownerUndecidedSelectionMutation, SaveHomeownerUndecidedSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveHomeownerUndecidedSelectionMutation, SaveHomeownerUndecidedSelectionMutationVariables>(SaveHomeownerUndecidedSelectionDocument, options);
      }
export type SaveHomeownerUndecidedSelectionMutationHookResult = ReturnType<typeof useSaveHomeownerUndecidedSelectionMutation>;
export type SaveHomeownerUndecidedSelectionMutationResult = Apollo.MutationResult<SaveHomeownerUndecidedSelectionMutation>;
export type SaveHomeownerUndecidedSelectionMutationOptions = Apollo.BaseMutationOptions<SaveHomeownerUndecidedSelectionMutation, SaveHomeownerUndecidedSelectionMutationVariables>;